
import React from 'react';
import { MainNotifications } from '../../layouts/MainNotifications/MainNotifications'

export const Notifications = () => {
  return (
    <MainNotifications />
  )
}
